import { PrimeIcons } from "primeng/api"

export const DASHBOARD_MENU = {
  label: "Tableau de bord",
  icon: PrimeIcons.WAVE_PULSE,
  routerLink: "dashboard",
  routing: { loadComponent: () => import("./dashboard.page").then((it) => it.DashboardPage) }
}